import { render } from "./OpenDoi.vue?vue&type=template&id=47a1d207"
import script from "./OpenDoi.vue?vue&type=script&lang=ts"
export * from "./OpenDoi.vue?vue&type=script&lang=ts"
script.render = render

export default script